module.exports = [
  {
    label: "Guitar",
    options: [{
        label: "Electric Guitar",
        value: "Electric Guitar"
      },
      {
        label: "Acoustic Guitar",
        value: "Acoustic Guitar"
      },
      {
        label: "Acoustic Electric Guitar",
        value: "Acoustic Electric Guitar"
      },
    ]
  },
  {
    label: "Folk & Traditional Stringed Instrument",
    options: [{
        label: "Ukuleles",
        value: "Ukuleles"
      },
      {
        label: "Banjos",
        value: "Banjos"
      },
      {
        label: "Mandolins",
        value: "Mandolins"
      },
      {
        value: "Resonators",
        label: "Resonators"
      },
      {
        value: "Lap steels",
        label: "Lap steels"
      },
      {
        value: "Latin Strings",
        label: "Latin Strings"
      },
      {
        value: "Banjoleles",
        label: "Banjoleles"
      },
      {
        value: "Cigar Box Instruments",
        label: "Cigar Box Instruments"
      },
      {
        value: "Dulcimers",
        label: "Dulcimers"
      },
      {
        value: "Ouds",
        label: "Ouds"
      },
      {
        value: "Autoharp",
        label: "Autoharp"
      }
    ]
  },
  {
    label: "Basses",
    options: [{
        label: "Electric Basses",
        value: "Electric Basses"
      },
      {
        label: "Acoustic Basses",
        value: "Acoustic Basses"
      },
      {
        label: "Double Basses",
        value: "Double Basses"
      }
    ]
  },
  {
    label: "Drums/Percussion",
    options: [{
        label: "Acoustic Drum set",
        value: "Acoustic Drum set"
      },
      {
        label: "Electronic Drum set",
        value: "Electronic Drum set"
      },
      {
        label: "Snare",
        value: "Snare"
      },
      {
        value: "Tambourines",
        label: "Tambourines"
      }, {
        value: "Cowbells",
        label: "Cowbells"
      }, {
        value: "Bar Chimes And Mark Trees",
        label: "Bar Chimes And Mark Trees"
      }, {
        value: "Timbales",
        label: "Timbales"
      }, {
        value: "Jam Blocks",
        label: "Jam Blocks"
      }, {
        value: "Steel Pan Drums",
        label: "Steel Pan Drums"
      }, {
        value: "Handpan",
        label: "Handpan"
      }, {
        value: "Bell Trees",
        label: "Bell Trees"
      },
      {
        value: "Cajons",
        label: "Cajons"
      }, {
        value: "Djembes",
        label: "Djembes"
      }, {
        value: "Congas",
        label: "Congas"
      }, {
        value: "Bongo",
        label: "Bongo"
      }, {
        value: "Doumbeks",
        label: "Doumbeks"
      }, {
        value: "Darbukas",
        label: "Darbukas"
      }, {
        value: "Tubanos",
        label: "Tubanos"
      }, {
        value: "Tongue Drum",
        label: "Tongue Drum"
      }, {
        value: "Ocean Drum",
        label: "Ocean Drum"
      }, {
        value: "Tabla",
        label: "Tabla"
      }, {
        value: "Frame Drum",
        label: "Frame Drum"
      }, {
        value: "Djun Djun",
        label: "Djun Djun"
      },
      {
        value: "Talking Drum",
        label: "Talking Drum"
      }, {
        value: "Singing Bowl",
        label: "Singing Bowl"
      },
      {
        value: "Cabasas",
        label: "Cabasas"
      }, {
        value: "Castanets",
        label: "Castanets"
      }, {
        value: "Claves",
        label: "Claves"
      }, {
        value: "Guiros",
        label: "Guiros"
      }, {
        value: "Jingle Sticks",
        label: "Jingle Sticks"
      }, {
        value: "Maracas",
        label: "Maracas"
      }, {
        value: "Rainsticks",
        label: "Rainsticks"
      }, {
        value: "Ratchet",
        label: "Ratchet"
      }, {
        value: "Shakers And Rattles",
        label: "Shakers And Rattles"
      }, {
        value: "Wah Wah Tube",
        label: "Wah Wah Tube"
      }, {
        value: "Slapstick",
        label: "Slapstick"
      }, {
        value: "Vibraslaps",
        label: "Vibraslaps"
      }, {
        value: "Flexatones",
        label: "Flexatones"
      },
      {
        value: "Samba Shakers",
        label: "Samba Shakers"
      }, {
        value: "Pandeiro",
        label: "Pandeiro"
      }, {
        value: "Agogo Bells",
        label: "Agogo Bells"
      }, {
        value: "Surdos",
        label: "Surdos"
      }, {
        value: "Tamborims",
        label: "Tamborims"
      }, {
        value: "Caixas",
        label: "Caixas"
      }, {
        value: "Cuicas Qweekas",
        label: "Cuicas (Qweekas)"
      }, {
        value: "Repiniques",
        label: "Repiniques"
      }, {
        value: "Marching Bass Drums",
        label: "Marching Bass Drums"
      }, {
        value: "Marching Tenor Drums",
        label: "Marching Tenor Drums"
      }, {
        value: "Marching Snare Drums",
        label: "Marching Snare Drums"
      }, {
        value: "Marching Cymbals",
        label: "Marching Cymbals"
      }, {
        value: "Marching Bells And Lyras",
        label: "Marching Bells And Lyras"
      }, {
        value: "Marching Xylophones",
        label: "Marching Xylophones"
      }, {
        value: "Marching Chimes",
        label: "Marching Chimes"
      }, {
        value: "Marching Marimbas",
        label: "Marching Marimbas"
      }, {
        value: "Marching Vibraphones",
        label: "Marching Vibraphones"
      }, {
        value: "Marching Pipe Band",
        label: "Marching Pipe Band"
      }, {
        value: "Concert Triangles",
        label: "Concert Triangles"
      }, {
        value: "Concert Tambourines",
        label: "Concert Tambourines"
      }, {
        value: "Concert Blocks",
        label: "Concert Blocks"
      }, {
        value: "Sleigh Bells",
        label: "Sleigh Bells"
      }, {
        value: "Concert Cymbals",
        label: "Concert Cymbals"
      }, {
        value: "Concert Drums",
        label: "Concert Drums"
      }, {
        value: "Concert Mallet Percussion",
        label: "Concert Mallet Percussion"
      }, {
        value: "Concert Marimbas",
        label: "Concert Marimbas"
      }, {
        value: "Concert Xylophones",
        label: "Concert Xylophones"
      }, {
        value: "Orchestra Bells",
        label: "Orchestra Bells"
      }, {
        value: "Glockenspiel",
        label: "Glockenspiel"
      }, {
        value: "Gong",
        label: "Gong"
      }

    ]
  },
  {
    label: "Keyboard & MIDI",
    options: [{
        label: "Digital Piano",
        value: "Digital Piano"
      },
      {
        label: "Synthesizers",
        value: "Synthesizers"
      }
    ]
  },
  {
    label: "DJ",
    value: "DJ"
  },
  {
    label: "Piano",
    value: "Piano"
  },
  {
    label: "Vocal (Male)",
    options: [{
      value: "Bass Male Vocal",
      label: "Bass (Male Vocal)"
    }, {
      value: "Baritone Male Vocal",
      label: "Baritone (Male Vocal)"
    }, {
      value: "Tenor Male Vocal",
      label: "Tenor (Male Vocal)"
    }, {
      value: "Alto Male Vocal",
      label: "Alto (Male Vocal)"
    }, {
      value: "Mezzo Soprano Male Vocal",
      label: "Mezzo Soprano (Male Vocal)"
    }, {
      value: "Soprano Male Vocal",
      label: "Soprano (Male Vocal)"
    },
    {
      value: "General Male vocal",
      label: "General (Male Vocal)"
    }]
  },
  {
    label: "Vocal (Female)",
    options: [{
      value: "Bass Female Vocal",
      label: "Bass (Female Vocal)"
    }, {
      value: "Baritone Female Vocal",
      label: "Baritone (Female Vocal)"
    }, {
      value: "Tenor Female Vocal",
      label: "Tenor (Female Vocal)"
    }, {
      value: "Alto Female Vocal",
      label: "Alto (Female Vocal)"
    }, {
      value: "Mezzo Soprano Female Vocal",
      label: "Mezzo Soprano (Female Vocal)"
    }, {
      value: "Soprano Female Vocal",
      label: "Soprano (Female Vocal)"
    },
    {
      value: "General Female vocal",
      label: "General (Female Vocal)"
    }
  ]
  },
  {
    label: "WoodWinds",
    options: [{
        value: "Clarinet",
        label: "Clarinet"
      }, {
        value: "Bassoons",
        label: "Bassoons"
      }, {
        value: "English Horns",
        label: "English Horns"
      }, {
        value: "Oboes",
        label: "Oboes"
      }, {
        value: "Piccolos",
        label: "Piccolos"
      }, {
        value: "Recorder",
        label: "Recorder"
      }, {
        value: "Alto Flutes",
        label: "Alto Flutes"
      },
      {
        value: "Bass Flutes",
        label: "Bass Flutes"
      },
      {
        value: "Alto Saxophone",
        label: "Alto Saxophone"
      }, {
        value: "Baritone Saxophone",
        label: "Baritone Saxophone"
      }, {
        value: "Bass Saxophone",
        label: "Bass Saxophone"
      }, {
        value: "Soprano Saxophone",
        label: "Soprano Saxophone"
      }, {
        value: "Tenor Saxophone",
        label: "Tenor Saxophone"
      }
    ]
  },
  {
    label: "Brass",
    options: [{
      value: "Bugle",
      label: "Bugle"
    }, {
      value: "Euphoniums",
      label: "Euphoniums"
    }, {
      value: "Flugelhorns",
      label: "Flugelhorns"
    }, {
      value: "Mellophone",
      label: "Mellophone"
    }, {
      value: "Sousaphones",
      label: "Sousaphones"
    }, {
      value: "Alto Horns",
      label: "Alto Horns"
    }, {
      value: "Tenor Horns",
      label: "Tenor Horns"
    }, {
      value: "Baritone Horns",
      label: "Baritone Horns"
    }, {
      value: "Eb Cornet",
      label: "Eb Cornet"
    }, {
      value: "Bb Cornet",
      label: "Bb Cornet"
    }, {
      value: "Double Horns",
      label: "Double Horns"
    }, {
      value: "Marching French Horns",
      label: "Marching French Horns"
    }, {
      value: "Natural French Horns",
      label: "Natural French Horns"
    }, {
      value: "Single French Horns",
      label: "Single French Horns"
    }, {
      value: "Bass Trombones",
      label: "Bass Trombones"
    }, {
      value: "Soprano Trombones",
      label: "Soprano Trombones"
    }, {
      value: "Tenor Trombones",
      label: "Tenor Trombones"
    }, {
      value: "Valve Trombones",
      label: "Valve Trombones"
    }, {
      value: "Bb Trumpets",
      label: "Bb Trumpets"
    }, {
      value: "C Trumpets",
      label: "C Trumpets"
    }, {
      value: "Eb Trumpets",
      label: "Eb Trumpets"
    }, {
      value: "D Trumpets",
      label: "D Trumpets"
    }, {
      value: "Bb Tubas",
      label: "Bb Tubas"
    }, {
      value: "C Tubas",
      label: "C Tubas"
    }, {
      value: "Eb Tubas",
      label: "Eb Tubas"
    }, {
      value: "F Tubas",
      label: "F Tubas"
    }]
  },
  {
    label: "String",
    options: [{
      value: "Violins",
      label: "Violins"
    }, {
      value: "Violas",
      label: "Violas"
    }, {
      value: "Harps",
      label: "Harps"
    }, {
      value: "Cellos",
      label: "Cellos"
    }, {
      value: "Double Basses",
      label: "Double Basses"
    }]
  },
  {
    label: "Mix Engineer",
    value: "Mix Engineer"
  },
  {
    label: "Music Producer",
    value: "Music Producer",
  },
  {
    label: "Songwriter",
    value: "Songwriter",
  },
  {
    label: "Music Arranger",
    value: "Music Arranger"
  },
  {
    label: "Composer",
    value: "Composer"
  },
  {
    label: "Arrangement",
    value: "Arrangement"
  },
  {
    label: "Other",
    value: "Other"
  }
]